/*
  Autosaves a status form when its select changes, except for values that need an
  explicit confirmation (they keep using the form's submit button).

  Example:
  <form data-controller="status-autosave"
        data-action="submit->status-autosave#submitted"
        data-status-autosave-manual-values-value='["approved","denied"]'>
    <select data-action="change->status-autosave#statusChanged"></select>
    <input type="submit" value="Update Status">
  </form>
*/
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    manualValues: { type: Array, default: [] },
    wait: { type: Number, default: 750 }
  }

  statusChanged(event) {
    clearTimeout(this.timeout)
    if (this.submitting) return
    if (this.manualValuesValue.includes(event.target.value)) return

    // Keyboard navigation can fire a change per option, so debounce before saving.
    this.timeout = setTimeout(() => this.element.requestSubmit(), this.waitValue)
  }

  // A submit from any source (autosave or the button) cancels a pending autosave, so
  // clicking the button mid-debounce can't post the transition twice. The flag is never
  // reset because update_status always redirects, which reconnects the controller; a
  // response that rendered in place instead would leave the form not autosaving.
  submitted() {
    clearTimeout(this.timeout)
    this.submitting = true
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
